import { authState } from "rxfire/auth";

import { auth } from "./firebase";

export const auth$ = authState(auth);
